import { Container, Schedule } from '@/components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SchedulePage.module.scss';

const SchedulePage: FC = () => {
  const { t } = useTranslation('schedule');

  return (
    <Container title={t('title')} className={styles.schedulePage}>
      <Schedule />
    </Container>
  );
};

export default SchedulePage;
